import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent } from "BaseComponent";
import MenuIcon from "MenuIcon";

class Paymentthankyoupage extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            btnLoading: false,
            invoiceid: {},
            payModal: false,
            loading: true,
        };
    }

    componentDidMount() {

    }

    renderLogoMenuIcon() {
        var menuIcon = { iconName: "", bsClass: "Logo", description: "" };
        return <MenuIcon key="StaticIcon" menuItem={menuIcon} />;
    }

    redirecttoLogin = () => {
            this.props.history.push("/login");
      
      };

    render() {
        let { clientinvoiceforpayment } = this.props;

        return (
            <>
                <div className="h-100">
                    <div className="dashboard-menu pull-left menu-animation">
                        <ul className="static-icon">{this.renderLogoMenuIcon()}</ul>
                    </div>
                    <div className="dashboard-navbar pull-top nav-animation">
                        <div className="warp-header-icon">
                            <div className="nav-bar-subtitle content-fadein-animation pull-left">
                                <div className="nav-bar-subtitle-title">
                                    {LocaleStrings.billing_payment_header}
                                </div>
                                <div className="nav-bar-subtitle-desc">
                                    {LocaleStrings.billing_payment_desc}
                                </div>
                            </div>
                            <div className="pull-right main-header-right-section">
                                <div className="d-flex justify-content-end">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="dashboard-content content-fadein-animation "
                        style={{
                            float: "left",
                            height: `100vh`,
                        }}
                    >
                        <div className="no-content-container">
                            <div className="no-content-message" style={{ fontSize: '20px' }}>
                                <div className='d-block'>
                                    <div className="">{LocaleStrings.thankyoupage_text}</div>
                                    <div className="">
                                         <Button
                                            className="btn-custom-blue schedule-add-button mt-4"
                                            onClick={() => this.redirecttoLogin()}
                                         >
                                        {LocaleStrings.login}
                                    </Button>
                                    </div>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        session: state.session,
        clientinvoiceforpayment: state.clientinvoiceforpayment
    };
}
export default connect(mapStateToProps, {
})(
    reduxForm({
        form: "PaymentthankyoupagelForm",
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
    })(Paymentthankyoupage)
);